import { PaperClipOutlined } from "@ant-design/icons";
import {
  Table,
  Row,
  Col,
  Button,
  Select,
  Input,
  Tooltip,
  message,
  Modal,
} from "antd";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store";
import { getActionsTabData, updateStatus } from "../../store/slices/mainSlice";
import { loadingIndicator } from "./transactions";
import { getKeyByValue } from "./usersmenu";
import { getUserFilesForAdmin, handlingTicketingAction } from "../../store/api";
import { isEmpty, isUndefined } from "lodash";
import { ViewDocument } from "../../utils/Utils";
import DetailsModal from "./detailsModal";
import { CreateManualMatch } from "./create_manualMatch_modal";
import type { ColumnsType } from "antd/es/table";
const { TextArea } = Input;
const SK_FILTER = "sk";
const DETAILS_FILTER = "details";
const CATEGORY_FILTER = "category_type";
const PK_FILTER = "pk";
const STATUS_FILTER = "status";
const REQUEST_FILTER = "details";
const { Search } = Input;
export interface itemInterface {
  key: React.Key;
  additional_info: string;
  quantity: string;
  created_at: string;
  request: string;
  FO_id: string;
  price_per_qtl: string;
  status: string;
  category_type: string;
  produce: string;
  intent_to_sell: string;
  category: string;
  variety: string;
  sk: string;
  pk: string;
  details: string;
  doc_location: string;
}
interface propType {
  name: string;
}
const OngoingActions = (props: propType) => {
  const dispatch = useDispatch();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [spinnerShow, setSpinnerShow] = useState(false);
  const [showDocument, setShowDocument] = useState(false);
  const [imageSrc, setImageSrc] = useState();
  const [isPDF, setPDF] = useState(false);
  const [detailsModalShow, setDetailsModalShow] = useState(false);
  const [recordDetails, setRecordDetails] = useState("");
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [dataSource, setDataSource] = useState([]);
  const [totalPassengers, setTotalPassengers] = useState(1);
  const [loading, setLoading] = useState(false);
  const [showManualMatch, setShowManualMatch] = useState(false);
  const [manualMatchRecord, setManualMatchRecord] = useState();

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setremarks("");
    setIsModalVisible(false);
  };
  const { requests, category_type, status, sk } = useSelector(
    (state: RootState) => state.main.actionsTabData
  );
  const user_destiny_data: any = useSelector(
    (state: RootState) => state.main.vbUserData.user_destiny_data
  );
  const { OnGoing, Completed }: any = useSelector(
    (state: RootState) => state.main.actionsTabData
  );

  const { isActionsTabData } = useSelector((state: RootState) => state.main);

  var tableData: any = props?.name === "ongoing" ? OnGoing : Completed;

  const tableDataLength = tableData.length;
  console.log(tableDataLength, "tableDataLength");

  const [allFilters, setAllFilters] = useState({
    pk: "",
    details: "",
    category_type: "",
    status: "",
    sk: "",
  });

  const [filteredData, setFilteredData]: any = useState([{}]);
  const [isFiltering, setIsFiltering] = useState(false);
  const [remarks, setremarks] = useState("");

  // useEffect(() => {
  //   // This one is to create all values for the selector fields, runs everytime ongoing data changes
  //   let category_type: Array<string> = [];
  //   let request_issue: Array<string> = [];
  //   let status: Array<string> = [];

  //   onGoingData.forEach((item: itemInterface) => {
  //     if (!category_type.includes(item.category_type))
  //       category_type.push(item.category_type);
  //     if (!request_issue.includes(item.request))
  //       request_issue.push(item.request);
  //     if (!status.includes(item.status)) status.push(item.status);
  //   });

  //   setSelectorValues({
  //     category_type: category_type,
  //     request_issue: request_issue,
  //     status: status,
  //   });
  // }, [onGoingData]);

  const updateAllFilters = (grp: string, val: string) => {
    if (val === "undefined") val = "";
    if (grp == "pk" && val != "") {
      console.log(val);
      console.log(getKeyByValue(user_destiny_data, val));
      val = val.toUpperCase();
      var c: any = getKeyByValue(user_destiny_data, val);
      if (c === "undefined" || c === undefined) val = "###^&*(^&*";
      else val = c;
      console.log(val);
    }
    val = val.toLowerCase();
    let currFilter: Record<string, string> = {};
    currFilter[`${grp}`] = val;
    setAllFilters((prevState) => {
      const f = { ...prevState, ...currFilter };
      return f;
    });
  };

  useEffect(() => {
    // Everytime the filters change, Need to do filtering... so
    doFilterV2();
  }, [allFilters]);

  const doFilterV2 = () => {
    let noOfFilters = 0;
    let isNestedFilter = false;

    for (const [key, value] of Object.entries(allFilters)) {
      if (value.length !== 0) noOfFilters++;
      if (noOfFilters > 1) {
        isNestedFilter = true;
        break;
      }
    } // if all values length is zero, It just mean that no filters are applied
    if (noOfFilters === 0) {
      setIsFiltering(false);
      return;
    }

    let finalFilteredData: Array<itemInterface> = [];

    const noEmptyVal = (v: string) => {
      if (!Boolean(v)) return "`";
      return v;
    };

    let allData: any = tableData;
    allData.forEach((item: itemInterface) => {
      if (isNestedFilter) {
        if (
          item.sk &&
          item.sk.includes(allFilters.sk) &&
          item.request &&
          item.request.includes(allFilters.details) &&
          // item.details.includes(allFilters.details) &&
          item.pk &&
          item.pk.includes(allFilters.pk) &&
          item.status &&
          item.status.includes(allFilters.status) &&
          item.category_type &&
          item.category_type.includes(allFilters.category_type)
        )
          finalFilteredData.push(item);
      } else {
        if (
          (item.sk && item.sk.includes(noEmptyVal(allFilters.sk))) ||
          (item.request &&
            item.request.includes(noEmptyVal(allFilters.details))) ||
          // item.details.includes(noEmptyVal(allFilters.details)) ||
          (item.pk && item.pk.includes(noEmptyVal(allFilters.pk))) ||
          (item.status &&
            item.status.includes(noEmptyVal(allFilters.status))) ||
          (item.category_type &&
            item.category_type.includes(noEmptyVal(allFilters.category_type)))
        )
          finalFilteredData.push(item);
      }
    });

    // To remove any duplicates, If created at is same,
    // Then we can be sure that it is a duplicate record we added in the list
    // Got it from stackoverflow :P
    finalFilteredData = finalFilteredData.filter(
      (value, index, self) =>
        index === self.findIndex((t) => t.created_at === value.created_at)
    );
    setIsFiltering(true);
    setFilteredData(finalFilteredData);
  };

  const { Option } = Select;

  const columns: ColumnsType<itemInterface> = [
    {
      title: (
        <Row>
          <Col span={24}>Action ID</Col>
          <Col span={24}>
            <Input
              className="filters"
              placeholder="Search"
              allowClear
              onChange={(val: any) =>
                updateAllFilters(SK_FILTER, val.target.value)
              }
            />
          </Col>
        </Row>
      ),
      dataIndex: "sk",
      key: "sk",
      render: (val: string) => {
        return (
          <>
            <Tooltip title={val}>
              <span style={{ paddingLeft: 5 }}>
                {val.slice(val.indexOf("#") + 1, val.indexOf("#") + 10)}..
              </span>
            </Tooltip>
          </>
        );
      },
    },
    {
      title: (
        <Row>
          <Col span={24}>Category</Col>
        </Row>
      ),
      dataIndex: "sk",
      key: "sk",
      render: (val: string) => {
        const sk = val.split("#")[0].toLocaleLowerCase();
        return (
          <>
            <Tooltip title={val}>
              <span style={{ paddingLeft: 5 }}>{sk}</span>
            </Tooltip>
          </>
        );
      },
    },
    // {
    //   title: (
    //     <>
    //       {props.name === "ongoing" ? (
    //         <Row>
    //           <Col span={24}>Request/Issue</Col>
    //           <Col span={24}>
    //             <Select
    //               allowClear
    //               className="filters"
    //               placeholder="Select"
    //               onChange={(val: any) =>
    //                 updateAllFilters(REQUEST_FILTER, `${val}`)
    //               }
    //             >
    //               {requests.map((val) =>
    //                 val ? <Option value={val}>{val}</Option> : null
    //               )}
    //             </Select>
    //           </Col>
    //         </Row>
    //       ) : null}
    //     </>
    //   ),
    //   dataIndex: "request",
    //   key: "request",
    // },
    {
      title: (
        <Row>
          <Col span={18}>Seller/BuyerID</Col>
          <Col span={18}>
            {/* <Search
              style={{ paddingTop: 10 }}
              allowClear={true}
              placeholder="search"
              onSearch={(val) => updateAllFilters(PK_FILTER, val)}
            /> */}
            <Input
              className="filters"
              placeholder="Search"
              allowClear
              onChange={(e: any) => updateAllFilters(PK_FILTER, e.target.value)}
            />
          </Col>
        </Row>
      ),
      key: "pk",
      dataIndex: "pk",
      render: (pk: any, record: any) => (
        <div>
          {user_destiny_data[pk] != "" ? (
            <div>
              <div>
                {record.pk.match(/\d+/)[0] + "/" + " " + user_destiny_data[pk]}
              </div>
              <div>
                {record.reqData?.buyer_id
                  ? record.reqData?.buyer_id.split("#")[1]
                  : record.reqData?.userId?.split("#")[1]}
              </div>
            </div>
          ) : (
            <>{record.pk.match(/\d+/)[0]}</>
          )}
          <br></br>
        </div>
      ),
    },
    {
      title: "Details",
      key: "sk",
      dataIndex: "sk",
      render: (sk: any, record: any) => (
        <>
          {record?.reqData && (
            <>
              <Button
                type="link"
                onClick={() => {
                  setDetailsModalShow(true);
                  setRecordDetails(record?.reqData);
                }}
              >
                View More
              </Button>
              <DetailsModal
                data={recordDetails}
                detailsModalShow={detailsModalShow}
                setDetailsModalShow={setDetailsModalShow}
              />
            </>
          )}
          <>{record?.files ? viewDocFunc(record) : null}</>
        </>
      ),
    },
    {
      title: props.name === "ongoing" ? "Action" : "Status",
      key: "pk",
      dataIndex: "pk",
      render: (status: any, record: any | itemInterface) => (
        <div key={record.pk}>
          {record.ticketingStatus === "onGoing" ||
          record.ticketingStatus === undefined ? (
            decideHtml(record?.pk, record?.sk, record)
          ) : (
            <p>{record.ticketingStatus}</p>
          )}
        </div>
      ),
    },
  ];

  const ACCEPT = "approved";
  const REJECT = "rejected";
  const ESCALATE_TO_ADMIN = "escalate to admin";

  let skey = "";
  let pkey = "";

  const [keyData, setKeyData] = useState({
    sKey: "",
    pKey: "",
  });

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleStatusChange = async (
    pk: string,
    sk: string,
    key: number,
    record: any
  ) => {
    // console.log(skey, pkey);
    let status = ACCEPT;
    switch (key) {
      case 0:
        status = ACCEPT;
        break;
      case 1:
        status = REJECT;
        break;
      default:
        status = ESCALATE_TO_ADMIN;
        console.log(status);
    }
    // console.log(pk, sk);
    // console.log(status, "status");
    // console.log(remarks, "remarks");
    const newRemark = !isUndefined(remarks) ? remarks : null;
    const newRecord =
      sk.includes("payment_confirmation") ||
      sk.includes("Requested_to_maunual_match") ||
      sk.includes("verification")
        ? record
        : null;
    const data = {
      username: pk,
      eventType: sk,
      record: newRecord,
      reason: newRemark,
      status,
    };
    console.log(data, "data");
    dispatch(handlingTicketingAction(data, setSpinnerShow));
    setremarks("");
  };

  const handleActionlessCase = (sk: any) => {
    console.log(sk, "sk in func");
    if (sk === "seller_matches") {
      return <p>Enquire with seller</p>;
    }
    if (sk === "payment_pending" || "match_rejected") {
      return <p>Enquire user</p>;
    }
    if (sk === "add_crop") {
      return <p>collect the samples</p>;
    }
  };

  const viewDocFunc = (record: any) => {
    return (
      <>
        {record?.files?.map((file: string, index: any) => {
          const filename = file;
          console.log(filename, "filename inside doc");
          return (
            <div key={index}>
              <Tooltip title={file}>
                <Button
                  type="link"
                  onClick={() => {
                    dispatch(getUserFilesForAdmin(file, setImageSrc, setPDF));
                    setShowDocument(true);
                  }}
                >
                  View Document
                </Button>
              </Tooltip>
              {showDocument && (
                <ViewDocument
                  url={imageSrc}
                  isPDF={isPDF}
                  setShowDocument={setShowDocument}
                />
              )}
            </div>
          );
        })}
      </>
    );
  };

  const showManualMatchFun = (record: any) => {
    console.log(record, "record");
    setManualMatchRecord(record);
    setShowManualMatch(true);
  };

  const decideHtml = (pk: string, sk: string, record: any) => {
    console.log(sk, "sk in admin");
    const sk1 = sk?.split("#")[0].toLocaleLowerCase();
    if (
      sk1 === "verification" ||
      sk1 === "user_blocked" ||
      sk1 === "payment_confirmation"
    ) {
      return (
        <Row gutter={[10, 10]} key={pk}>
          <Col span={12}>
            <Button
              onClick={() => handleStatusChange(pk, sk, 0, record)}
              className="approveButton"
              block
              type="primary"
            >
              Approve
            </Button>
          </Col>
          <Col span={12}>
            <Button
              block
              onClick={() => {
                pkey = pk;
                skey = sk;

                setKeyData({
                  sKey: sk,
                  pKey: pk,
                });
                showModal();
              }}
              className="rejectButton"
            >
              Reject
            </Button>
            <Modal
              title="Remarks"
              open={isModalVisible}
              onOk={(e) => {
                if (remarks.length == 0) {
                  handleCancel();
                  return;
                }

                handleStatusChange(keyData.pKey, keyData.sKey, 1, record);
                setIsModalVisible((prev: any) => !prev);
              }}
              onCancel={handleCancel}
              centered
            >
              <TextArea
                rows={4}
                style={{ marginTop: "-20px" }}
                onChange={(e) => {
                  setremarks(e.target.value);
                }}
                value={remarks}
                required={true}
              />
            </Modal>
          </Col>
          <Col span={24}>
            <Button
              className="escalateButtonStyle"
              onClick={() => {
                pkey = pk;
                skey = sk;
                handleStatusChange(pk, sk, 2, record);
              }}
              block
            >
              Escalate to Admin
            </Button>
          </Col>
        </Row>
      );
    } else if (sk1 === "requested_to_maunual_match") {
      return (
        <Row gutter={[10, 10]} key={pk}>
          <Button
            onClick={() => showManualMatchFun(record)}
            className="approveButton"
            block
            type="primary"
          >
            CreateMatch
          </Button>
          <Modal
            title="Match Details"
            footer={null}
            closeIcon={null}
            open={showManualMatch}
          >
            <CreateManualMatch
              record={manualMatchRecord}
              setShowManualMatch={setShowManualMatch}
              handleStatusChange={handleStatusChange}
            />
          </Modal>
        </Row>
      );
    } else {
      handleActionlessCase(sk1);
    }

    // )} else if (text && text.includes("pending")) {
    //   return (
    //     <Row gutter={[10, 10]}>
    //       <Col span={12}>
    //         <Button
    //           onClick={() => {
    //             pkey = pk;
    //             skey = sk;
    //             handleStatusChange(pk, sk, 0, remarks);
    //           }}
    //           className="approveButton"
    //           block
    //           type="primary"
    //         >
    //           Approve
    //         </Button>
    //       </Col>
    //       <Col span={12}>
    //         <Button
    //           block
    //           onClick={() => {
    //             pkey = pk;
    //             skey = sk;
    //             handleStatusChange(pk, sk, 1, remarks);
    //           }}
    //           className="rejectButton"
    //         >
    //           Reject
    //         </Button>
    //       </Col>
    //       <Col span={24}>
    //         <Button
    //           className="escalateButtonStyle"
    //           onClick={() => {
    //             pkey = pk;
    //             skey = sk;
    //             console.log("escalate........");
    //             console.log(skey);
    //             console.log(pkey);
    //             handleStatusChange(pk, sk, 2, remarks);
    //           }}
    //           block
    //         >
    //           Escalate to Admin
    //         </Button>
    //       </Col>
    //     </Row>
    //   );
    // } else if (text.includes("auto escalated to admin")) {
    //   return (
    //     <Row gutter={[10, 10]}>
    //       <Col span={12}>
    //         <Button
    //           onClick={() => handleStatusChange(pk, sk, 0, remarks)}
    //           className="approveButton"
    //           block
    //           type="primary"
    //           disabled
    //         >
    //           Approve
    //         </Button>
    //       </Col>
    //       <Col span={12}>
    //         <Button
    //           block
    //           onClick={() => handleStatusChange(pk, sk, 1, remarks)}
    //           className="rejectButton"
    //           disabled
    //         >
    //           Reject
    //         </Button>
    //       </Col>
    //       <Col span={24}>
    //         <Button
    //           className="escalateButtonStyle"
    //           onClick={() => handleStatusChange(pk, sk, 2, remarks)}
    //           block
    //           disabled
    //         >
    //           Escalate to Admin
    //         </Button>
    //       </Col>
    //     </Row>
    //   );
    // } else if (text === "to be resolved") {
    //   return (
    //     <Row gutter={[8, 8]}>
    //       <Col span={20}>
    //         <Button block type="primary" className="esolveButton">
    //           Mark as resolved
    //         </Button>
    //       </Col>
    //       <Col span={20}>
    //         <Button className="escalateButtonStyle" block>
    //           Escalate to admin
    //         </Button>
    //       </Col>
    //     </Row>
    //   );
    // }
  };

  const getObjectsByValues = (newSelectedRowKeys: any, onGoingData: any) => {
    return onGoingData
      .filter((item: any) => newSelectedRowKeys.includes(item.key))
      .map((value: any) => value.sk);
  };

  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    setSelectedRowKeys(newSelectedRowKeys);
    const foundObjects = getObjectsByValues(newSelectedRowKeys, tableData);
  };
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };
  return (
    <div className="ongoing-actions">
      {!isActionsTabData || spinnerShow ? (
        loadingIndicator
      ) : (
        <>
          <Button
            type="primary"
            danger
            // onClick={start}
            // disabled={!hasSelected}
            // loading={loading}
          >
            Delete
          </Button>
          <Table
            rowSelection={rowSelection}
            columns={columns}
            dataSource={isFiltering ? filteredData : tableData}
            pagination={{
              // current: pagination.current,
              pageSize: 8,
              total: tableDataLength,
              // onChange: handleTableChange,
            }}
            scroll={{ x: 1350 }}
          />
        </>
      )}
    </div>
  );
};

export default OngoingActions;
